/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */
import Footer from './Footer';
import { SelectLang } from './RightContent';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';
import { AIButton} from "./AI/AIButton";
import AIFloatingChat from "./AI/AIFloatingChat";
import AIChatDrawer from "./AI/AIChatDrawer";

export { AvatarDropdown, AvatarName, Footer, AIButton, AIFloatingChat, AIChatDrawer, SelectLang };
